import { BaseError, type BaseErrorParameters } from './base';

export class WalletAlreadyLinkedToAnotherUserError extends BaseError {
  constructor({ cause }: Pick<BaseErrorParameters, 'cause'>) {
    super({
      cause,
      code: 'wallet_already_linked_to_another_user_error',
      docsUrl: null,
      name: 'WalletAlreadyLinkedToAnotherUserError',
      shortMessage: 'This wallet is already linked to another user',
    });
  }
}
